<template>
  <div class="history-wrapper">
    <h3>我的足迹</h3>
    <div class="items-list">
      <template v-for="(item, index) in list">
        <BaseItem :source="item" :enableFavorite="true" :enableBuyNow="true" :key="index" />
      </template>
    </div>
  </div>
</template>

<script>
import BaseItem from "@/components/BaseItem.vue";
import types from "@/store/types";
import api from "@/utils/api";

export default {
  name: "History",
  components: { BaseItem },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.loadSource();
  },
  methods: {
    loadSource() {
      api[types.FOOTPRINT_LIST]().then(res => {
        if (res.code == 1) {
          this.list = res.data.list;
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .history-wrapper {
    h3 { color:#333333; font-weight:bold; font-size: 1.125rem; padding: 1.6875rem 0 1.25rem 0; display: none; }
    .items-list {
      display: flex; flex-wrap: wrap; padding: 0 1rem;
      & /deep/ .plugin-wrapper {
        width: calc((100% - 20px) / 2); margin: 20px 20px 0 0;
        &:nth-child(-n+2) { margin-top: 0; }
        &:nth-child(2n) { margin-right: 0; }
      }
    }
  }
  
  @media screen and (min-width: 48em) {
    .history-wrapper {
      h3 { display: block; }
    }
  }

  @media screen and (min-width: 64em) {
    .history-wrapper {
      .items-list {
        display: flex; flex-wrap: wrap; padding: 0; margin-top: 30px;
        & /deep/ .plugin-wrapper {
          width: calc((100% - 40px) / 3);
          &:nth-child(-n+3) { margin-top: 0; }
          &:nth-child(2n) { margin-right: 20px; }
          &:nth-child(3n) { margin-right: 0; }
        }
      }
    }
  }
</style>